import moment from 'moment'
import { useNavigate } from 'react-router-dom'
const { useEffect, useCallback } = require('react')

const useJourneyExpiration = ({ countryCode }) => {
  const navigate = useNavigate()

  const checkJourneyExpiration = useCallback(() => {
    const userData = JSON.parse(localStorage.getItem('userData'))

    if (userData?.created_at) {
      const expirationDate = moment(userData.created_at).add(1, 'days').format('YYYY-MM-DD')

      if (moment().isAfter(expirationDate)) {
        localStorage.clear();
        navigate(`/mis-examenes/${countryCode}`)
      }
    } else {
      addTimeToJourney();
    }
  }, [countryCode, navigate])

  useEffect(() => {
    checkJourneyExpiration()
  }, [checkJourneyExpiration])

  const addTimeToJourney = () => {
    const userData = JSON.parse(localStorage.getItem('userData'))

    if (userData) {
      if (!userData.created_at) {
        const expirationDate = moment().format('YYYY-MM-DD')

        localStorage.setItem('userData', JSON.stringify({
          ...userData,
          created_at: expirationDate
        }))
      }
    }
  }
}

export default useJourneyExpiration